import { gql } from '@apollo/client'

export const GET_DXO_EXECUTION_FOR_DIRECT_REPORTS = gql`
  query GetDXOExecutionForDirectReports($input: DXOExecutionForUserInput!) {
    dxoExecutionForDirectReports(input: $input) {
      results {
        id
        name
        address
        numDistinctPriorities
        compliancePercentage
        previousCompliancePercentage
        compliancePercentChange
        numDistinctPriorities
        numStores
        numAuditedStores
        deployedExecuteNumerator
        deployedExecuteDenominator
        deployedSellNumerator
        deployedSellDenominator
        correctPricingPercentage
      }
      count
    }
  }
`
